// extracted by mini-css-extract-plugin
export default {"rating":"rD-z","numberOfStars":"sD-z","count":"tD-z","barGraphSpacing":"uD-z","barGraph":"vD-z"};